import React, { useContext } from 'react';
import { NavigationApi } from '@/navigation/NavigationProvider.tsx';

// @ts-expect-error
export const Navigation = React.createContext<NavigationApi>({});

export const useNavigation = () => {
  return useContext(Navigation);
};
